import Vue from 'vue';
import Preview from './src/preview.vue'

Vue.use(Preview)

/* istanbul ignore next */
Preview.install = function (Vue) {
  Vue.component(Preview.name, Preview);
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/photo-preview/index.js